/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import dockerSVG from 'assets/resources/pages/software-services/logo/docker.svg';
import kubernetesSVG from 'assets/resources/pages/software-services/logo/kubernetes2.svg';
import terraformSVG from 'assets/resources/pages/software-services/logo/terraform.svg';
import gitSVG from 'assets/resources/pages/software-services/logo/git2.svg';
import vagrantSVG from 'assets/resources/pages/software-services/logo/vagrant.svg';

export default [
  {
    src: dockerSVG,
    nameClass: 'img-fluid',
    alt: 'dev ops icon'
  },
  {
    src: kubernetesSVG,
    nameClass: 'img-fluid',
    alt: 'dev ops icon'
  },
  {
    src: terraformSVG,
    nameClass: 'img-fluid',
    alt: 'dev ops icon'
  },
  {
    src: gitSVG,
    nameClass: 'img-fluid',
    alt: 'dev ops icon'
  },
  {
    src: vagrantSVG,
    nameClass: 'img-fluid',
    alt: 'dev ops icon'
  }
]